export const AUDIT_JOB_RUN_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.AuditJobRun.AmbiguousColumnReference';
export const AUDIT_JOB_RUN_FAILURE_CANCELED = 'europa.job.management.AuditJobRun.Canceled';
export const AUDIT_JOB_RUN_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.AuditJobRun.CannotCastValueOfType';
export const AUDIT_JOB_RUN_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.AuditJobRun.ClientConnectionError';
export const AUDIT_JOB_RUN_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.AuditJobRun.DataLoadingFailed';
export const AUDIT_JOB_RUN_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.AuditJobRun.DatabaseNotExistsOrNotAuthorized';
export const AUDIT_JOB_RUN_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.AuditJobRun.InsufficientPrivileges';
export const AUDIT_JOB_RUN_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.AuditJobRun.InsufficientTaskPrivileges';
export const AUDIT_JOB_RUN_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.AuditJobRun.InvalidAccessToken';
export const AUDIT_JOB_RUN_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.AuditJobRun.InvalidAccountName';
export const AUDIT_JOB_RUN_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.AuditJobRun.InvalidIdentifier';
export const AUDIT_JOB_RUN_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.AuditJobRun.InvalidParameterTypeForFunction';
export const AUDIT_JOB_RUN_SUCCESS_JOB_RUN_AUDIT_RESULT =
    'europa.job.management.AuditJobRun.JobRunAuditResult';
export const AUDIT_JOB_RUN_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.AuditJobRun.MaxFileSizeExceeded';
export const AUDIT_JOB_RUN_FAILURE_MISSING_COLUMN =
    'europa.job.management.AuditJobRun.MissingColumn';
export const AUDIT_JOB_RUN_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.AuditJobRun.NoActiveWarehouseSelected';
export const AUDIT_JOB_RUN_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.AuditJobRun.NotAuthenticatedToSnowflake';
export const AUDIT_JOB_RUN_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.AuditJobRun.NotExistsOrNotAuthorized';
export const AUDIT_JOB_RUN_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.AuditJobRun.NotExistsOrOperationCannotBePerformed';
export const AUDIT_JOB_RUN_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.AuditJobRun.ObjectAlreadyExists';
export const AUDIT_JOB_RUN_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.AuditJobRun.SchemaNotExistsOrNotAuthorized';
export const AUDIT_JOB_RUN_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.AuditJobRun.SnowflakeInternalServerError';
export const AUDIT_JOB_RUN_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.AuditJobRun.SnowflakeNotConfigured';
export const AUDIT_JOB_RUN_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.AuditJobRun.SnowflakeQueryCanceled';
export const AUDIT_JOB_RUN_FAILURE_TIMEOUT = 'europa.job.management.AuditJobRun.Timeout';
export const AUDIT_JOB_RUN_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.AuditJobRun.UncategorizedSqlError';
export const AUDIT_JOB_RUN_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.AuditJobRun.UnexpectedFailure';
export const AUDIT_JOB_RUN_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.AuditJobRun.UnknownFunction';
export const AUDIT_JOB_RUN_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.AuditJobRun.UnknownFunctions';
export const AUDIT_JOB_RUN_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.AuditJobRun.UserDiffersFromToken';
export const AUDIT_JOB_RUN_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.AuditJobRun.ValueNotRecognized';
export const AUDIT_JOB_RUN_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.AuditJobRun.WarehouseSuspended';
export const CANCEL_JOB_RUN_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.CancelJobRun.AmbiguousColumnReference';
export const CANCEL_JOB_RUN_FAILURE_CANCELED = 'europa.job.management.CancelJobRun.Canceled';
export const CANCEL_JOB_RUN_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.CancelJobRun.CannotCastValueOfType';
export const CANCEL_JOB_RUN_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.CancelJobRun.ClientConnectionError';
export const CANCEL_JOB_RUN_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.CancelJobRun.DataLoadingFailed';
export const CANCEL_JOB_RUN_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CancelJobRun.DatabaseNotExistsOrNotAuthorized';
export const CANCEL_JOB_RUN_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.CancelJobRun.InsufficientPrivileges';
export const CANCEL_JOB_RUN_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.CancelJobRun.InsufficientTaskPrivileges';
export const CANCEL_JOB_RUN_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.CancelJobRun.InvalidAccessToken';
export const CANCEL_JOB_RUN_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.CancelJobRun.InvalidAccountName';
export const CANCEL_JOB_RUN_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.CancelJobRun.InvalidIdentifier';
export const CANCEL_JOB_RUN_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.CancelJobRun.InvalidParameterTypeForFunction';
export const CANCEL_JOB_RUN_SUCCESS_JOB_RUN_CANCEL_REQUESTED =
    'europa.job.management.CancelJobRun.JobRunCancelRequested';
export const CANCEL_JOB_RUN_FAILURE_JOB_RUN_NOT_CANCELABLE =
    'europa.job.management.CancelJobRun.JobRunNotCancelable';
export const CANCEL_JOB_RUN_FAILURE_JOB_RUN_NOT_FOUND =
    'europa.job.management.CancelJobRun.JobRunNotFound';
export const CANCEL_JOB_RUN_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.CancelJobRun.MaxFileSizeExceeded';
export const CANCEL_JOB_RUN_FAILURE_MISSING_COLUMN =
    'europa.job.management.CancelJobRun.MissingColumn';
export const CANCEL_JOB_RUN_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.CancelJobRun.NoActiveWarehouseSelected';
export const CANCEL_JOB_RUN_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.CancelJobRun.NotAuthenticatedToSnowflake';
export const CANCEL_JOB_RUN_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CancelJobRun.NotExistsOrNotAuthorized';
export const CANCEL_JOB_RUN_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.CancelJobRun.NotExistsOrOperationCannotBePerformed';
export const CANCEL_JOB_RUN_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.CancelJobRun.ObjectAlreadyExists';
export const CANCEL_JOB_RUN_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CancelJobRun.SchemaNotExistsOrNotAuthorized';
export const CANCEL_JOB_RUN_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.CancelJobRun.SnowflakeInternalServerError';
export const CANCEL_JOB_RUN_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.CancelJobRun.SnowflakeNotConfigured';
export const CANCEL_JOB_RUN_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.CancelJobRun.SnowflakeQueryCanceled';
export const CANCEL_JOB_RUN_FAILURE_TIMEOUT = 'europa.job.management.CancelJobRun.Timeout';
export const CANCEL_JOB_RUN_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.CancelJobRun.UncategorizedSqlError';
export const CANCEL_JOB_RUN_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.CancelJobRun.UnexpectedFailure';
export const CANCEL_JOB_RUN_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.CancelJobRun.UnknownFunction';
export const CANCEL_JOB_RUN_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.CancelJobRun.UnknownFunctions';
export const CANCEL_JOB_RUN_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.CancelJobRun.UserDiffersFromToken';
export const CANCEL_JOB_RUN_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.CancelJobRun.ValueNotRecognized';
export const CANCEL_JOB_RUN_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.CancelJobRun.WarehouseSuspended';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.CancelJobRunQueries.AmbiguousColumnReference';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.CancelJobRunQueries.CannotCastValueOfType';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.CancelJobRunQueries.ClientConnectionError';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.CancelJobRunQueries.DataLoadingFailed';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CancelJobRunQueries.DatabaseNotExistsOrNotAuthorized';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.CancelJobRunQueries.InsufficientPrivileges';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.CancelJobRunQueries.InsufficientTaskPrivileges';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.CancelJobRunQueries.InvalidAccessToken';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.CancelJobRunQueries.InvalidAccountName';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.CancelJobRunQueries.InvalidIdentifier';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.CancelJobRunQueries.InvalidParameterTypeForFunction';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.CancelJobRunQueries.MaxFileSizeExceeded';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_MISSING_COLUMN =
    'europa.job.management.CancelJobRunQueries.MissingColumn';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.CancelJobRunQueries.NoActiveWarehouseSelected';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.CancelJobRunQueries.NotAuthenticatedToSnowflake';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CancelJobRunQueries.NotExistsOrNotAuthorized';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.CancelJobRunQueries.NotExistsOrOperationCannotBePerformed';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.CancelJobRunQueries.ObjectAlreadyExists';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CancelJobRunQueries.SchemaNotExistsOrNotAuthorized';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.CancelJobRunQueries.SnowflakeInternalServerError';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.CancelJobRunQueries.SnowflakeNotConfigured';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.CancelJobRunQueries.SnowflakeQueryCanceled';
export const CANCEL_JOB_RUN_QUERIES_SUCCESS_SUCCEEDED =
    'europa.job.management.CancelJobRunQueries.Succeeded';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_TIMEOUT =
    'europa.job.management.CancelJobRunQueries.Timeout';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.CancelJobRunQueries.UncategorizedSqlError';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.CancelJobRunQueries.UnexpectedFailure';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.CancelJobRunQueries.UnknownFunction';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.CancelJobRunQueries.UnknownFunctions';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.CancelJobRunQueries.UserDiffersFromToken';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.CancelJobRunQueries.ValueNotRecognized';
export const CANCEL_JOB_RUN_QUERIES_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.CancelJobRunQueries.WarehouseSuspended';
export const CHECK_DATA_FRESHNESS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.CheckDataFreshness.AmbiguousColumnReference';
export const CHECK_DATA_FRESHNESS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.CheckDataFreshness.CannotCastValueOfType';
export const CHECK_DATA_FRESHNESS_FAILURE_DATA_FRESHNESS_CHECK_NOT_MET =
    'europa.job.management.CheckDataFreshness.DataFreshnessCheckNotMet';
export const CHECK_DATA_FRESHNESS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CheckDataFreshness.DatabaseNotExistsOrNotAuthorized';
export const CHECK_DATA_FRESHNESS_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.CheckDataFreshness.InvalidIdentifier';
export const CHECK_DATA_FRESHNESS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.CheckDataFreshness.InvalidParameterTypeForFunction';
export const CHECK_DATA_FRESHNESS_FAILURE_MISSING_COLUMN =
    'europa.job.management.CheckDataFreshness.MissingColumn';
export const CHECK_DATA_FRESHNESS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CheckDataFreshness.NotExistsOrNotAuthorized';
export const CHECK_DATA_FRESHNESS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.CheckDataFreshness.SchemaNotExistsOrNotAuthorized';
export const CHECK_DATA_FRESHNESS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.CheckDataFreshness.UncategorizedSqlError';
export const CHECK_DATA_FRESHNESS_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.CheckDataFreshness.UnknownFunction';
export const CHECK_DATA_FRESHNESS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.CheckDataFreshness.UnknownFunctions';
export const CHECK_DATA_FRESHNESS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.CheckDataFreshness.ValueNotRecognized';
export const CHECK_SEQUENTIAL_JOB_RUN_FAILURE_SEQUENTIAL_JOB_RUN_CHECK_NOT_MET =
    'europa.job.management.CheckSequentialJobRun.SequentialJobRunCheckNotMet';
export const COMPLETE_JOB_RUN_SUCCESS_JOB_RUN_COMPLETED =
    'europa.job.management.CompleteJobRun.JobRunCompleted';
export const COMPLETE_JOB_RUN_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.CompleteJobRun.UnexpectedFailure';
export const DELETE_JOB_DEFINITION_SUCCESS_SUCCEEDED =
    'europa.job.management.DeleteJobDefinition.Succeeded';
export const DELETE_JOB_DEFINITION_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.DeleteJobDefinition.UnexpectedFailure';
export const DELETE_JOB_ENVIRONMENT_SUCCESS_SUCCEEDED =
    'europa.job.management.DeleteJobEnvironment.Succeeded';
export const DELETE_JOB_ENVIRONMENT_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.DeleteJobEnvironment.UnexpectedFailure';
export const DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_CANCELED =
    'europa.job.management.DeleteSnowflakeServiceAccountUser.Canceled';
export const DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER_SUCCESS_SNOWFLAKE_SERVICE_ACCOUNT_USER_DELETED =
    'europa.job.management.DeleteSnowflakeServiceAccountUser.SnowflakeServiceAccountUserDeleted';
export const DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_TIMEOUT =
    'europa.job.management.DeleteSnowflakeServiceAccountUser.Timeout';
export const DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.DeleteSnowflakeServiceAccountUser.UnexpectedFailure';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.ExecuteQueryByEnvironment.AmbiguousColumnReference';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.ExecuteQueryByEnvironment.CannotCastValueOfType';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.ExecuteQueryByEnvironment.ClientConnectionError';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.ExecuteQueryByEnvironment.DataLoadingFailed';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.ExecuteQueryByEnvironment.DatabaseNotExistsOrNotAuthorized';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.ExecuteQueryByEnvironment.InsufficientPrivileges';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.ExecuteQueryByEnvironment.InsufficientTaskPrivileges';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.ExecuteQueryByEnvironment.InvalidAccessToken';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.ExecuteQueryByEnvironment.InvalidAccountName';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.ExecuteQueryByEnvironment.InvalidIdentifier';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.ExecuteQueryByEnvironment.InvalidParameterTypeForFunction';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.ExecuteQueryByEnvironment.MaxFileSizeExceeded';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_MISSING_COLUMN =
    'europa.job.management.ExecuteQueryByEnvironment.MissingColumn';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.ExecuteQueryByEnvironment.NoActiveWarehouseSelected';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.ExecuteQueryByEnvironment.NotAuthenticatedToSnowflake';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.ExecuteQueryByEnvironment.NotExistsOrNotAuthorized';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.ExecuteQueryByEnvironment.NotExistsOrOperationCannotBePerformed';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.ExecuteQueryByEnvironment.ObjectAlreadyExists';
export const EXECUTE_QUERY_BY_ENVIRONMENT_SUCCESS_RESULT_RECORDS =
    'europa.job.management.ExecuteQueryByEnvironment.ResultRecords';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.ExecuteQueryByEnvironment.SchemaNotExistsOrNotAuthorized';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.ExecuteQueryByEnvironment.SnowflakeInternalServerError';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.ExecuteQueryByEnvironment.SnowflakeNotConfigured';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.ExecuteQueryByEnvironment.SnowflakeQueryCanceled';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_TIMEOUT =
    'europa.job.management.ExecuteQueryByEnvironment.Timeout';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.ExecuteQueryByEnvironment.UncategorizedSqlError';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ExecuteQueryByEnvironment.UnexpectedFailure';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.ExecuteQueryByEnvironment.UnknownFunction';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.ExecuteQueryByEnvironment.UnknownFunctions';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.ExecuteQueryByEnvironment.UserDiffersFromToken';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.ExecuteQueryByEnvironment.ValueNotRecognized';
export const EXECUTE_QUERY_BY_ENVIRONMENT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.ExecuteQueryByEnvironment.WarehouseSuspended';
export const EXECUTE_QUERY_BY_SERVICE_ACCOUNT_SUCCESS_RESULT_RECORDS =
    'europa.job.management.ExecuteQueryByServiceAccount.ResultRecords';
export const EXECUTE_QUERY_BY_SERVICE_ACCOUNT_FAILURE_SECRET_NOT_FOUND =
    'europa.job.management.ExecuteQueryByServiceAccount.SecretNotFound';
export const EXECUTE_QUERY_BY_SERVICE_ACCOUNT_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ExecuteQueryByServiceAccount.UnexpectedFailure';
export const GET_JOB_ACTIVITY_METRICS_SUCCESS_JOB_ACTIVITY_METRICS =
    'europa.job.management.GetJobActivityMetrics.JobActivityMetrics';
export const GET_JOB_ACTIVITY_METRICS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobActivityMetrics.UnexpectedFailure';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.GetJobCheckCandidates.AmbiguousColumnReference';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.GetJobCheckCandidates.CannotCastValueOfType';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.GetJobCheckCandidates.ClientConnectionError';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.GetJobCheckCandidates.DataLoadingFailed';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.GetJobCheckCandidates.DatabaseNotExistsOrNotAuthorized';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.GetJobCheckCandidates.InsufficientPrivileges';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.GetJobCheckCandidates.InsufficientTaskPrivileges';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.GetJobCheckCandidates.InvalidAccessToken';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.GetJobCheckCandidates.InvalidAccountName';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.GetJobCheckCandidates.InvalidIdentifier';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.GetJobCheckCandidates.InvalidParameterTypeForFunction';
export const GET_JOB_CHECK_CANDIDATES_SUCCESS_JOB_CHECK_CANDIDATES =
    'europa.job.management.GetJobCheckCandidates.JobCheckCandidates';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.GetJobCheckCandidates.MaxFileSizeExceeded';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_MISSING_COLUMN =
    'europa.job.management.GetJobCheckCandidates.MissingColumn';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.GetJobCheckCandidates.NoActiveWarehouseSelected';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.GetJobCheckCandidates.NotAuthenticatedToSnowflake';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.GetJobCheckCandidates.NotExistsOrNotAuthorized';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.GetJobCheckCandidates.NotExistsOrOperationCannotBePerformed';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.GetJobCheckCandidates.ObjectAlreadyExists';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.GetJobCheckCandidates.SchemaNotExistsOrNotAuthorized';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.GetJobCheckCandidates.SnowflakeInternalServerError';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.GetJobCheckCandidates.SnowflakeNotConfigured';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.GetJobCheckCandidates.SnowflakeQueryCanceled';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_TIMEOUT =
    'europa.job.management.GetJobCheckCandidates.Timeout';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.GetJobCheckCandidates.UncategorizedSqlError';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobCheckCandidates.UnexpectedFailure';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.GetJobCheckCandidates.UnknownFunction';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.GetJobCheckCandidates.UnknownFunctions';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.GetJobCheckCandidates.UserDiffersFromToken';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.GetJobCheckCandidates.ValueNotRecognized';
export const GET_JOB_CHECK_CANDIDATES_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.GetJobCheckCandidates.WarehouseSuspended';
export const GET_JOB_DEFINITION_SUCCESS_JOB_DEFINITION_DETAILED_ENTRY =
    'europa.job.management.GetJobDefinition.JobDefinitionDetailedEntry';
export const GET_JOB_DEFINITION_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobDefinition.UnexpectedFailure';
export const GET_JOB_OPERATION_COUNTS_SUCCESS_JOB_OPERATION_COUNTS =
    'europa.job.management.GetJobOperationCounts.JobOperationCounts';
export const GET_JOB_OPERATION_COUNTS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobOperationCounts.UnexpectedFailure';
export const GET_JOB_RUN_SUCCESS_JOB_RUN_ENTRY = 'europa.job.management.GetJobRun.JobRunEntry';
export const GET_JOB_RUN_FAILURE_JOB_RUN_NOT_FOUND =
    'europa.job.management.GetJobRun.JobRunNotFound';
export const GET_JOB_RUN_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobRun.UnexpectedFailure';
export const GET_JOB_RUN_FILTER_OPTIONS_SUCCESS_JOB_RUN_FILTER_OPTIONS =
    'europa.job.management.GetJobRunFilterOptions.JobRunFilterOptions';
export const GET_JOB_RUN_FILTER_OPTIONS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobRunFilterOptions.UnexpectedFailure';
export const GET_JOB_RUN_STATUS_FAILURE_JOB_RUN_NOT_FOUND =
    'europa.job.management.GetJobRunStatus.JobRunNotFound';
export const GET_JOB_RUN_STATUS_SUCCESS_JOB_RUN_STATUS_DETAILS =
    'europa.job.management.GetJobRunStatus.JobRunStatusDetails';
export const GET_JOB_RUN_STATUS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobRunStatus.UnexpectedFailure';
export const GET_JOB_RUN_TIMELINE_SUCCESS_JOB_RUN_TIMELINE =
    'europa.job.management.GetJobRunTimeline.JobRunTimeline';
export const GET_JOB_RUN_TIMELINE_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.GetJobRunTimeline.UnexpectedFailure';
export const LIST_JOB_DEFINITIONS_SUCCESS_JOB_DEFINITIONS =
    'europa.job.management.ListJobDefinitions.JobDefinitions';
export const LIST_JOB_DEFINITIONS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ListJobDefinitions.UnexpectedFailure';
export const LIST_JOB_ENVIRONMENTS_SUCCESS_JOB_ENVIRONMENTS =
    'europa.job.management.ListJobEnvironments.JobEnvironments';
export const LIST_JOB_ENVIRONMENTS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ListJobEnvironments.UnexpectedFailure';
export const LIST_JOB_RUNS_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.job.management.ListJobRuns.EntityNotFoundOrNotAccessible';
export const LIST_JOB_RUNS_SUCCESS_JOB_RUNS = 'europa.job.management.ListJobRuns.JobRuns';
export const LIST_JOB_RUNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ListJobRuns.UnexpectedFailure';
export const LIST_SNOWFLAKE_SERVICE_ACCOUNT_USERS_FAILURE_SECRET_NOT_FOUND =
    'europa.job.management.ListSnowflakeServiceAccountUsers.SecretNotFound';
export const LIST_SNOWFLAKE_SERVICE_ACCOUNT_USERS_SUCCESS_SNOWFLAKE_SERVICE_ACCOUNT_USERS =
    'europa.job.management.ListSnowflakeServiceAccountUsers.SnowflakeServiceAccountUsers';
export const LIST_SNOWFLAKE_SERVICE_ACCOUNT_USERS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ListSnowflakeServiceAccountUsers.UnexpectedFailure';
export const PAUSE_JOB_TRIGGER_SUCCESS_SUCCEEDED =
    'europa.job.management.PauseJobTrigger.Succeeded';
export const PAUSE_JOB_TRIGGER_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.PauseJobTrigger.UnexpectedFailure';
export const RESUME_JOB_TRIGGER_SUCCESS_SUCCEEDED =
    'europa.job.management.ResumeJobTrigger.Succeeded';
export const RESUME_JOB_TRIGGER_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.ResumeJobTrigger.UnexpectedFailure';
export const SET_JOB_DEFINITION_SUCCESS_JOB_DEFINITION_CREATED =
    'europa.job.management.SetJobDefinition.JobDefinitionCreated';
export const SET_JOB_DEFINITION_SUCCESS_JOB_DEFINITION_UPDATED =
    'europa.job.management.SetJobDefinition.JobDefinitionUpdated';
export const SET_JOB_DEFINITION_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.SetJobDefinition.UnexpectedFailure';
export const SET_JOB_ENVIRONMENT_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.SetJobEnvironment.AmbiguousColumnReference';
export const SET_JOB_ENVIRONMENT_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.SetJobEnvironment.CannotCastValueOfType';
export const SET_JOB_ENVIRONMENT_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.SetJobEnvironment.ClientConnectionError';
export const SET_JOB_ENVIRONMENT_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.SetJobEnvironment.DataLoadingFailed';
export const SET_JOB_ENVIRONMENT_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.SetJobEnvironment.DatabaseNotExistsOrNotAuthorized';
export const SET_JOB_ENVIRONMENT_FAILURE_EVENT_ID_NOT_FOUND =
    'europa.job.management.SetJobEnvironment.EventIdNotFound';
export const SET_JOB_ENVIRONMENT_FAILURE_EVENT_SUBSCRIPTION_NOT_FOUND =
    'europa.job.management.SetJobEnvironment.EventSubscriptionNotFound';
export const SET_JOB_ENVIRONMENT_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.SetJobEnvironment.InsufficientPrivileges';
export const SET_JOB_ENVIRONMENT_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.SetJobEnvironment.InsufficientTaskPrivileges';
export const SET_JOB_ENVIRONMENT_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.SetJobEnvironment.InvalidAccessToken';
export const SET_JOB_ENVIRONMENT_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.SetJobEnvironment.InvalidAccountName';
export const SET_JOB_ENVIRONMENT_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.SetJobEnvironment.InvalidIdentifier';
export const SET_JOB_ENVIRONMENT_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.SetJobEnvironment.InvalidParameterTypeForFunction';
export const SET_JOB_ENVIRONMENT_SUCCESS_JOB_ENVIRONMENT_CREATED =
    'europa.job.management.SetJobEnvironment.JobEnvironmentCreated';
export const SET_JOB_ENVIRONMENT_SUCCESS_JOB_ENVIRONMENT_UPDATED =
    'europa.job.management.SetJobEnvironment.JobEnvironmentUpdated';
export const SET_JOB_ENVIRONMENT_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.SetJobEnvironment.MaxFileSizeExceeded';
export const SET_JOB_ENVIRONMENT_FAILURE_MISSING_COLUMN =
    'europa.job.management.SetJobEnvironment.MissingColumn';
export const SET_JOB_ENVIRONMENT_FAILURE_NAME_ALREADY_EXISTS =
    'europa.job.management.SetJobEnvironment.NameAlreadyExists';
export const SET_JOB_ENVIRONMENT_FAILURE_NAME_CANNOT_BE_BLANK =
    'europa.job.management.SetJobEnvironment.NameCannotBeBlank';
export const SET_JOB_ENVIRONMENT_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.SetJobEnvironment.NoActiveWarehouseSelected';
export const SET_JOB_ENVIRONMENT_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.SetJobEnvironment.NotAuthenticatedToSnowflake';
export const SET_JOB_ENVIRONMENT_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.SetJobEnvironment.NotExistsOrNotAuthorized';
export const SET_JOB_ENVIRONMENT_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.SetJobEnvironment.NotExistsOrOperationCannotBePerformed';
export const SET_JOB_ENVIRONMENT_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.SetJobEnvironment.ObjectAlreadyExists';
export const SET_JOB_ENVIRONMENT_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.SetJobEnvironment.SchemaNotExistsOrNotAuthorized';
export const SET_JOB_ENVIRONMENT_FAILURE_SECRET_NOT_FOUND =
    'europa.job.management.SetJobEnvironment.SecretNotFound';
export const SET_JOB_ENVIRONMENT_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.SetJobEnvironment.SnowflakeInternalServerError';
export const SET_JOB_ENVIRONMENT_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.SetJobEnvironment.SnowflakeNotConfigured';
export const SET_JOB_ENVIRONMENT_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.SetJobEnvironment.SnowflakeQueryCanceled';
export const SET_JOB_ENVIRONMENT_FAILURE_SNOWFLAKE_SERVICE_ACCOUNT_USER_NOT_EXISTS =
    'europa.job.management.SetJobEnvironment.SnowflakeServiceAccountUserNotExists';
export const SET_JOB_ENVIRONMENT_FAILURE_TIMEOUT =
    'europa.job.management.SetJobEnvironment.Timeout';
export const SET_JOB_ENVIRONMENT_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.SetJobEnvironment.UncategorizedSqlError';
export const SET_JOB_ENVIRONMENT_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.SetJobEnvironment.UnexpectedFailure';
export const SET_JOB_ENVIRONMENT_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.SetJobEnvironment.UnknownFunction';
export const SET_JOB_ENVIRONMENT_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.SetJobEnvironment.UnknownFunctions';
export const SET_JOB_ENVIRONMENT_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.SetJobEnvironment.UserDiffersFromToken';
export const SET_JOB_ENVIRONMENT_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.SetJobEnvironment.ValueNotRecognized';
export const SET_JOB_ENVIRONMENT_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.SetJobEnvironment.WarehouseSuspended';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.management.SetSnowflakeServiceAccountUser.AmbiguousColumnReference';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_CANCELED =
    'europa.job.management.SetSnowflakeServiceAccountUser.Canceled';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.management.SetSnowflakeServiceAccountUser.CannotCastValueOfType';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.management.SetSnowflakeServiceAccountUser.ClientConnectionError';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_DATA_LOADING_FAILED =
    'europa.job.management.SetSnowflakeServiceAccountUser.DataLoadingFailed';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.SetSnowflakeServiceAccountUser.DatabaseNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.management.SetSnowflakeServiceAccountUser.InsufficientPrivileges';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.management.SetSnowflakeServiceAccountUser.InsufficientTaskPrivileges';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.management.SetSnowflakeServiceAccountUser.InvalidAccessToken';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.management.SetSnowflakeServiceAccountUser.InvalidAccountName';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_INVALID_IDENTIFIER =
    'europa.job.management.SetSnowflakeServiceAccountUser.InvalidIdentifier';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.management.SetSnowflakeServiceAccountUser.InvalidParameterTypeForFunction';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.management.SetSnowflakeServiceAccountUser.MaxFileSizeExceeded';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_MISSING_COLUMN =
    'europa.job.management.SetSnowflakeServiceAccountUser.MissingColumn';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.management.SetSnowflakeServiceAccountUser.NoActiveWarehouseSelected';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.management.SetSnowflakeServiceAccountUser.NotAuthenticatedToSnowflake';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.SetSnowflakeServiceAccountUser.NotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.management.SetSnowflakeServiceAccountUser.NotExistsOrOperationCannotBePerformed';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.management.SetSnowflakeServiceAccountUser.ObjectAlreadyExists';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.management.SetSnowflakeServiceAccountUser.SchemaNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.management.SetSnowflakeServiceAccountUser.SnowflakeInternalServerError';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.management.SetSnowflakeServiceAccountUser.SnowflakeNotConfigured';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.management.SetSnowflakeServiceAccountUser.SnowflakeQueryCanceled';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_SUCCESS_SNOWFLAKE_SERVICE_ACCOUNT_CREATED =
    'europa.job.management.SetSnowflakeServiceAccountUser.SnowflakeServiceAccountCreated';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_SUCCESS_SNOWFLAKE_SERVICE_ACCOUNT_UPDATED =
    'europa.job.management.SetSnowflakeServiceAccountUser.SnowflakeServiceAccountUpdated';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_TIMEOUT =
    'europa.job.management.SetSnowflakeServiceAccountUser.Timeout';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.management.SetSnowflakeServiceAccountUser.UncategorizedSqlError';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.SetSnowflakeServiceAccountUser.UnexpectedFailure';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.management.SetSnowflakeServiceAccountUser.UnknownFunction';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.management.SetSnowflakeServiceAccountUser.UnknownFunctions';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.management.SetSnowflakeServiceAccountUser.UserDiffersFromToken';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.management.SetSnowflakeServiceAccountUser.ValueNotRecognized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.management.SetSnowflakeServiceAccountUser.WarehouseSuspended';
export const SUBMIT_JOB_RUN_FAILURE_CANCELED = 'europa.job.management.SubmitJobRun.Canceled';
export const SUBMIT_JOB_RUN_FAILURE_EVENT_ID_NOT_FOUND =
    'europa.job.management.SubmitJobRun.EventIdNotFound';
export const SUBMIT_JOB_RUN_FAILURE_JOB_RUN_CHECK_FAILED =
    'europa.job.management.SubmitJobRun.JobRunCheckFailed';
export const SUBMIT_JOB_RUN_FAILURE_JOB_RUN_SKIPPED =
    'europa.job.management.SubmitJobRun.JobRunSkipped';
export const SUBMIT_JOB_RUN_SUCCESS_JOB_RUN_SUBMITTED =
    'europa.job.management.SubmitJobRun.JobRunSubmitted';
export const SUBMIT_JOB_RUN_FAILURE_NAME_ALREADY_EXISTS =
    'europa.job.management.SubmitJobRun.NameAlreadyExists';
export const SUBMIT_JOB_RUN_FAILURE_NAME_CANNOT_BE_BLANK =
    'europa.job.management.SubmitJobRun.NameCannotBeBlank';
export const SUBMIT_JOB_RUN_FAILURE_TIMEOUT = 'europa.job.management.SubmitJobRun.Timeout';
export const SUBMIT_JOB_RUN_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.SubmitJobRun.UnexpectedFailure';
export const TRIGGER_JOB_RUN_FAILURE_CANCELED = 'europa.job.management.TriggerJobRun.Canceled';
export const TRIGGER_JOB_RUN_FAILURE_EVENT_ID_NOT_FOUND =
    'europa.job.management.TriggerJobRun.EventIdNotFound';
export const TRIGGER_JOB_RUN_FAILURE_JOB_RUN_CHECK_FAILED =
    'europa.job.management.TriggerJobRun.JobRunCheckFailed';
export const TRIGGER_JOB_RUN_FAILURE_JOB_RUN_SKIPPED =
    'europa.job.management.TriggerJobRun.JobRunSkipped';
export const TRIGGER_JOB_RUN_SUCCESS_JOB_RUN_TRIGGERED =
    'europa.job.management.TriggerJobRun.JobRunTriggered';
export const TRIGGER_JOB_RUN_FAILURE_NAME_ALREADY_EXISTS =
    'europa.job.management.TriggerJobRun.NameAlreadyExists';
export const TRIGGER_JOB_RUN_FAILURE_NAME_CANNOT_BE_BLANK =
    'europa.job.management.TriggerJobRun.NameCannotBeBlank';
export const TRIGGER_JOB_RUN_FAILURE_TIMEOUT = 'europa.job.management.TriggerJobRun.Timeout';
export const TRIGGER_JOB_RUN_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.TriggerJobRun.UnexpectedFailure';
export const TRIGGER_JOB_RUN_API_FAILURE_API_KEY_NOT_FOUND =
    'europa.job.management.TriggerJobRunApi.ApiKeyNotFound';
export const TRIGGER_JOB_RUN_API_FAILURE_JOB_DEFINITION_NOT_FOUND =
    'europa.job.management.TriggerJobRunApi.JobDefinitionNotFound';
export const TRIGGER_JOB_RUN_API_SUCCESS_JOB_RUN_API_TRIGGERED =
    'europa.job.management.TriggerJobRunApi.JobRunApiTriggered';
export const TRIGGER_JOB_RUN_API_FAILURE_JOB_RUN_SKIPPED =
    'europa.job.management.TriggerJobRunApi.JobRunSkipped';
export const TRIGGER_JOB_RUN_API_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.TriggerJobRunApi.UnexpectedFailure';
export const TRIGGER_JOB_RUNS_SUCCESS_JOB_RUNS_TRIGGERED =
    'europa.job.management.TriggerJobRuns.JobRunsTriggered';
export const TRIGGER_JOB_RUNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.management.TriggerJobRuns.UnexpectedFailure';
